// Test IDs pour le composant générique DataTable (tri, recherche, export).
export const TABLE = {
  searchInput: 'table-search-input',
  exportExcelButton: 'table-export-excel-button',
  exportPdfButton: 'table-export-pdf-button',
  sortHeader: 'table-sort-header',
  row: 'table-row',
  resizeHandle: 'table-resize-handle',
  columnFilter: 'table-column-filter',
  resetFiltersButton: 'table-reset-filters-button',
};

// Test IDs pour les pavés KPI cliquables (filtrent le tableau associé, ou
// sont ouverts en un clic depuis les Alertes Sécurité du Dashboard).
export const QUICK_FILTER_KPI = {
  actionsTotal: 'actions-kpi-total',
  actionsOpen: 'actions-kpi-open',
  actionsLate: 'actions-kpi-late',
  findingsTotal: 'findings-kpi-total',
  findingsHigh: 'findings-kpi-high',
  findingsOpen: 'findings-kpi-open',
  findingsLate: 'findings-kpi-late',
  ccvTotal: 'ccv-kpi-total',
  ccvOpen: 'ccv-kpi-open',
  ccvLate: 'ccv-kpi-late',
  pcedTotal: 'pced-kpi-total',
  pcedValidated: 'pced-kpi-validated',
  pcedPending: 'pced-kpi-pending',
};
